import {  QUERY_GET_WORKSHOP_TYPES} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getWorkshopTypes = baseThunk("workshopTypes/workshopTypesList", QUERY_GET_WORKSHOP_TYPES, "GET")